// Generated by genversion.
module.exports = '2.4.16'
